
import { Page404Component } from './page404/page404.component';
import { NgbdCarouselBasic } from './portada/carousel-basic.component';
import { NovedadesComponent } from './novedades/novedades.component';
import { ServiciosComponent } from './servicios/servicios.component';
import { ContactosComponent } from './contactos/contactos.component';
import { ArticuloComponent } from './articulo/articulo.component';
import { HomeComponent } from './home/home.component';
import { MetodologiaComponent } from './metodologia/metodologia.component';

import { NgModule  } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';


const routes: Routes = [
  

    //{path: '', component: LoginComponent,
    
     { path: '', component: HomeComponent,


       children: [
     
     // { path: '', component: LoginComponent },
      { path: '', component: NgbdCarouselBasic },
      { path: 'page404', component: Page404Component },
      { path: 'portada', component: NgbdCarouselBasic },
      { path: 'planes', component: NovedadesComponent       },
      { path: 'servicios', component: ServiciosComponent       },
      { path: 'como-trabajamos', component: MetodologiaComponent },
      { path: 'politicas-de-privacidad', component: ContactosComponent       },
      { path: 'contacto', component: NgbdCarouselBasic},
      { path: 'contactanos', component: ContactosComponent},
      { path: 'servicio/:id', component: ServiciosComponent},
       { path: 'desarrollo-web/:id', component: ArticuloComponent},
    ]
  },
  
 
  { path: '**', component: Page404Component }



];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false, initialNavigation: 'enabled' })],
  exports: [RouterModule],
  // providers: [{provide: LocationStrategy, useClass: HashLocationStrategy}]
})
export class AppRoutingModule {}

